import { useTranslation } from 'react-i18next';
import React from 'react';
import { DefaultModalProps, withLocationStateModal } from 'utils/modals';

import { Button, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { DefaultModal } from '@libs/ui/components/modals';

import { ApplicationFormModals } from './types';

// Define props interface extending DefaultModalProps
interface SubmittingCandidateModalProps extends DefaultModalProps<void> {
  jobId: string;
}

const useStyles = makeStyles((theme) => ({
  modal: {
    maxWidth: '400px',
  },
}));

// Create the modal component implementation
const SubmittingCandidateModalComponent = ({
  close,
  isOpen,
}: SubmittingCandidateModalProps) => {
  const { t } = useTranslation('jobForm');
  const classes = useStyles();
  const customClose = () => {
    close();
  };

  return (
    <DefaultModal
      open={isOpen}
      className={classes.modal}
      handleClose={customClose}
      title={t('applicationForm.submitting.title')}
      actions={
        <Grid container>
          <Grid item xs={12}>
            <Button
              fullWidth
              color="info"
              variant="contained"
              onClick={customClose}
            >
              SOUNDS GOOD
            </Button>
          </Grid>
        </Grid>
      }
    >
      <Typography variant="body1" align="center" sx={{ mt: 8 }}>
        We have started submitting your candidate, it may take a couple of
        minutes
      </Typography>
    </DefaultModal>
  );
};

// Export wrapped component with HOC
export const SubmittingCandidateModal = withLocationStateModal<void>({
  id: ApplicationFormModals.SUBMITTING_CANDIDATE,
})(SubmittingCandidateModalComponent);
